export default function(regex, str){
    if(!(typeof regex instanceof RegExp)){
        regex = new RegExp(regex, "g");
    }
    return regex.test(str);
}
